import { Link } from '@tanstack/react-router'
import styles from './PricingSection.module.css'

type PricingTier = {
  tier: string
  name: string
  price: string
  desc: string
  features: Array<{ text: string; included: boolean }>
  ctaLabel: string
  ctaVariant: 'ghost' | 'solid'
  featured?: boolean
}

const TIERS: PricingTier[] = [
  {
    tier: 'Free',
    name: 'Banco de reservas',
    price: '0',
    desc: 'Tudo que precisa pra começar — ligas com amigos, pontuação ao vivo e os 3 formatos.',
    features: [
      { text: 'Ligas privadas com amigos', included: true },
      { text: 'Pontuação ao vivo', included: true },
      { text: '3 formatos: Pontos, H2H, Sobrevivente', included: true },
      { text: 'Ranking global', included: true },
      { text: 'Notificações de gol', included: true },
    ],
    ctaLabel: 'Criar conta',
    ctaVariant: 'ghost',
  },
  {
    tier: 'Pro',
    name: 'XI Titular',
    price: '19',
    desc: 'Pra quem joga em várias competições e quer destravar prize pools de verdade.',
    features: [
      { text: 'Tudo do Free', included: true },
      { text: 'Competições ilimitadas', included: true },
      { text: 'Regras 100% customizáveis', included: true },
      { text: 'Ligas pagas (até R$ 100/entrada)', included: true },
      { text: 'Notificações de lineup', included: true },
    ],
    ctaLabel: 'Começar Pro',
    ctaVariant: 'solid',
    featured: true,
  },
  {
    tier: 'Elite',
    name: 'Capitão da seleção',
    price: '49',
    desc: 'Pra power-users — ligas multi-competição, big money, e acesso antecipado a tudo.',
    features: [
      { text: 'Tudo do Pro', included: true },
      { text: 'Ligas pagas sem teto de entrada', included: true },
      { text: 'Comissário multi-liga', included: true },
      { text: 'Suporte prioritário', included: true },
      { text: '✦ Beta de novos esportes primeiro', included: true },
    ],
    ctaLabel: 'Começar Elite',
    ctaVariant: 'ghost',
  },
]

export function PricingSection() {
  return (
    <>
      <section className={styles.section} id="planos" style={{ paddingTop: 0 }}>
        <div className={styles.sectionHead}>
          <div>
            <div className={styles.num}>04 / PLANOS</div>
            <h2 className={styles.heading}>
              Joga grátis.<br />
              Sobe quando quiser.
            </h2>
          </div>
          <div className={styles.headRight}>
            Ligas com amigos são sempre gratuitas. Pro destrava analytics e ligas pagas com prize pool real.
          </div>
        </div>

        <div className={styles.pricing}>
          {TIERS.map((tier) => (
            <div key={tier.tier} className={`${styles.card} ${tier.featured ? styles.cardFeatured : ''}`}>
              <div className={styles.priceTier}>{tier.tier}</div>
              <div className={styles.priceName}>{tier.name}</div>
              <div className={styles.priceTag}>
                <span className={styles.priceCurr}>R$</span>
                {tier.price}
                <span className={styles.pricePer}>/mês</span>
              </div>
              <p className={styles.priceDesc}>{tier.desc}</p>
              <ul className={styles.featureList}>
                {tier.features.map((f) => (
                  <li key={f.text} className={f.included ? '' : styles.featureMuted}>
                    <span className={styles.check}>{f.included ? '✓' : '—'}</span>
                    {f.text}
                  </li>
                ))}
              </ul>
              <Link
                to="/entrar"
                search={{ redirect: undefined, code: undefined, error: undefined }}
                className={`${styles.btn} ${tier.ctaVariant === 'solid' ? styles.btnSolid : styles.btnGhost}`}
              >
                {tier.ctaLabel}
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA block */}
      <div className={styles.ctaBlock}>
        <div className={styles.ctaEyebrow}>● COPA DE SELEÇÕES 2026 · COMEÇA EM BREVE</div>
        <div className={styles.ctaTitle}>
          MONTA O XI.<br />
          <span className={styles.ctaGlow}>OU ASSISTE.</span>
        </div>
        <p className={styles.ctaDesc}>
          O apito sai em breve. Monta agora ou volta pra ver os outros pontuarem.
        </p>
        <div className={styles.ctaRow}>
          <Link
            to="/entrar"
            search={{ redirect: undefined, code: undefined, error: undefined }}
            className={styles.ctaBtnSolid}
          >
            Montar meu time grátis →
          </Link>
          <a href="#como-funciona" className={styles.ctaBtnGhost}>Ver como funciona</a>
        </div>
      </div>
    </>
  )
}
